import { render } from "./HeadPhones.vue?vue&type=template&id=e0a1f654&lang=html"
import script from "./HeadPhones.vue?vue&type=script&lang=js"
export * from "./HeadPhones.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__